export const EDialogType = {
  medium: "md",
  large: "large",
  xlarge: "xlarge",
};
